import { render } from "./material.html?vue&type=template&id=11f97ec6&scoped=true&external"
import script from "./material.vue?vue&type=script&lang=js"
export * from "./material.vue?vue&type=script&lang=js"

import "./material.vue?vue&type=style&index=0&id=11f97ec6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11f97ec6"]])

export default __exports__